import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// The project's global button reset zeros out SweetAlert2's --swal2-* CSS
// variables, leaving buttons as transparent outlines. Use buttonsStyling: false
// + Tailwind classes via customClass so button styling is applied directly.
const DEFAULT_ALERT_OPTS = {
  title: 'Are you sure?',
  text: 'Once deleted, you will not be able to recover this!',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes',
  cancelButtonText: 'Cancel',
  reverseButtons: true,
  buttonsStyling: false,
  customClass: {
    confirmButton: 'inline-flex items-center px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg ml-2',
    cancelButton: 'inline-flex items-center px-4 py-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg'
  }
}

// eslint-disable-next-line import/prefer-default-export
export const confirmAlert = (opts = {}) => Swal.fire({ ...DEFAULT_ALERT_OPTS, ...opts })
  .then((result) => result.isConfirmed)
